module.exports = __webpack_public_path__ + "img/LOGO.3266650e.png";